// Data layer event tracking for Google Tag Manager
export function sendDataLayerEvent(
  event: string,
  fields?: { [key: string]: string | undefined }
) {
  // If we're in production, send the event.
  if (process.env.NODE_ENV === "production") {
    if (typeof window !== "undefined" && "dataLayer" in window) {
      (window.dataLayer as any).push({ event, ...fields });
    }
  } else {
    // If we're not in production, just log the event.
    console.log("Data Layer Event:", event, fields);
  }
}
